
export function deshabilitarAutocompletado (elementoDOM) {
    let elementos = elementoDOM.querySelectorAll ('input');
    elementos.forEach ((e) => {
      if (e.type.localeCompare ("email") == 0 || e.type.localeCompare("password") == 0) {
        e.setAttribute ('autocomplete', 'off');
        e.setAttribute ('readonly', 'readonly');
        setTimeout(() => {
          e.removeAttribute('readonly');
        }, 750);
      }
    });
}

export default {
  isIOS() {
    if(/iPhone/i.test(navigator.userAgent)) {
      return true
    } else {
      return false
    }
  },
  
  getPlatformClass() {
    if (this.isIOS()) {
      return 'cssios';
    }
    return 'cssnormal';
  },

  getPlatformClassH() {
    if (this.isIOS()) {
      return 'cssiosh';
    }
    return 'cssnormalh';
  },
    


}
